import React from 'react';
import { Switch } from 'react-router-dom';
import UsersAndPermissions from './users-and-permissions';

function UsersAndPermissionsScene() {
  return (
    <Switch>
      <UsersAndPermissions />
    </Switch>
  );
}

export default UsersAndPermissionsScene;
